import actions from '../../store/actions'
import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { UpdateSlateRequest } from '../../resources/slate/types'
import { CurrentSlateResponse } from '../../resources/establishment/types'
import { useDispatch } from '../redux'

export const useUpdateSlate = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const updateSlate = (payload: UpdateSlateRequest): Promise<CurrentSlateResponse> => {
        setInProgress(true)
        return mutations
            .updateSlate(payload)
            .then((response) => {
                setInProgress(false)
                dispatch(actions.setCurrentSlate(response))
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        updateSlate,
        inProgress,
    }
}
